import { makeStyles } from '@mui/styles';

export const useForm = makeStyles((theme) => ({
    box:{
        width: '100%'
    }

}))